import React, { useEffect } from 'react';
import './LoadingScreen.css';

function LoadingScreen({ onFinishLoading }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinishLoading();
    }, 0o0);

    return () => clearTimeout(timer);
  }, [onFinishLoading]);

  const text = "                   Hello. I am Ahmad Jabbar, and I am a full stack developer, app developer and a data scientist";
  const words = text.split(" ");

  return (
    <div className="loading-screen">
      <video autoPlay muted loop className="video-bg">
        <source src="/video2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="loading-text">
        <span>{text}</span>
      </div>
    </div>
  );
}

export default LoadingScreen;
